<div class="product-group" [class.product-group--readonly]="readOnly()">
  <ng-content select="[productHeader]" />

  <div class="product-group__order-items">
    <ng-content />
  </div>

  @if (isCategoryAvailable()) {
    @if (promoTagLabels().length > 0 && formattedSavings()) {
      <div class="product-group__promo">
        <div class="product-group__promo-tags">
          @for (label of promoTagLabels(); track $index) {
            <pxw-tag type="success" size="xs">{{ label }}</pxw-tag>
          }
        </div>
        <span class="product-group__promo-savings"> -{{ formattedSavings() }} </span>
      </div>
    }

    @if (!readOnly() && formattedSubtotal()) {
      <div class="product-group__subtotal">
        <span class="product-group__subtotal-label">{{ subtotalLabel() }}</span>
        <span class="product-group__subtotal-amount">{{ formattedSubtotal() }}</span>
      </div>
    }
  }
</div>
